import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import styles from "./styles/Inbox.module.scss";
import { CardTitle, Input } from "../../Components/CustomComponents";

import { FiSend } from "react-icons/fi";
import { IoIosArrowBack } from "react-icons/io";
import { useSocket } from "../../Context/SocketContext";
import { useChatContext } from "./context/ChatContext";
import { Form, Spinner } from "react-bootstrap";
import _ from "lodash";
import { useSelector } from "react-redux";
import { getMessageTime } from "../../Helper";
import { FaTrashAlt } from "react-icons/fa";
import Toast from "../../Hooks/useToast";
import { v4 as uuidv4 } from "uuid";
import DeleteModal from "../../Components/Modals/DeleteModal";

export default function Inbox({ isMobile = false }) {
  const { socket, isSocketConnected } = useSocket();
  //   const user = useSelector((state) => state.auth?.user);
  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("userInfo")) || {};
    } catch {
      return {};
    }
  }, []);
  // console.log(`user`, user);

  const { setChatRoom, chatRoom, updateLastMessagePayload } = useChatContext();

  // console.log(`chatRoom`, chatRoom);

  const chatContainerRef = useRef(null);
  const popupRef = useRef(null);
  const messageRef = useRef();
  const popoverRef = useRef(null);

  const INITIAL_CHAT_HISTORY = useMemo(() => {
    return {
      isError: false,
      isLoading: true,
      data: [],
    };
  }, []);

  const [page, setPage] = useState(1);
  const [chatHistory, setChatHistory] = useState(INITIAL_CHAT_HISTORY);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [addMemberModal, setAddMemberModal] = useState(false);
  const [editGroupModal, setEditGroupModal] = useState(false);
  const [isMessageDeleteModal, setMessageDeleteModal] = useState(false);
  const [media, setMedia] = useState(undefined);
  const [popupData, setPopupData] = useState({});
  const [message, setMessage] = useState();

  useEffect(() => {
    if (isSocketConnected) {
      socket.on("loadChatHistory_", (data) => {
        setChatHistory((prev) => {
          return {
            ...prev,
            isLoading: false,
            data: data?.data || [],
          };
        });
      });
      socket.on("deleteChatMessage_", (data) => {
        // console.log(`deleteChatMessage_`, data);
        setChatHistory((prev) => {
          return {
            ...prev,
            data: prev.data.filter(
              (item) => item.message_id !== data.payload.message_id
            ),
          };
        });
      });
    }

    return () => {
      if (isSocketConnected) {
        socket.dispose("loadChatHistory_");
        socket.dispose("deleteChatMessage_");
      }
    };
  }, [isSocketConnected]);

  useEffect(() => {
    if (isSocketConnected) {
      socket.on("receivedMessage_", (data) => {
        const message = data?.data;
        if (message?.chat_room_id !== chatRoom.id) return;
        if (message.user_id !== user.id) {
          setChatHistory((prev) => {
            return {
              ...prev,
              data: [...prev?.data, message],
            };
          });
        } else {
          if (_.isUndefined(data?.payload?.message_uuid)) {
            setChatHistory((prev) => {
              return {
                ...prev,
                data: [...prev?.data, message],
              };
            });
          } else {
            setChatHistory((prev) => {
              return {
                ...prev,
                data: [
                  ...prev?.data.filter(
                    (item) => item.message_uuid !== data?.payload.message_uuid
                  ),
                  message,
                ],
              };
            });
          }
        }
        updateLastMessagePayload(message);
        socket.emit("_resetMessageCount", { chat_room_id: chatRoom.id });
      });
    }

    return () => {
      if (isSocketConnected) {
        socket.dispose("receivedMessage_");
      }
    };
  }, [isSocketConnected, chatRoom, socket, updateLastMessagePayload, user]);

  const scrollChatContainer = () => {
    const container = document.getElementById("chatContainer");
    container.scroll({ top: container.scrollHeight, behavior: "smooth" });
  };

  const handleClickOutside = (event) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      setIsPopoverOpen(false);
    }

    if (popupRef.current && !popupRef.current.contains(event.target)) {
      popupRef.current.style.display = "none";
    }
  };

  useEffect(() => {
    scrollChatContainer();
  }, [chatHistory?.data.length]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(chatRoom) && page > 1) {
      socket.emit("_loadChatHistory", { chat_room_id: chatRoom.id });
    }
  }, [page, socket, chatRoom]);

  useEffect(() => {
    if (!chatHistory.isLoading) {
      setChatHistory(INITIAL_CHAT_HISTORY);
    }

    if (!_.isEmpty(chatRoom)) {
      socket.emit("_loadChatHistory", { chat_room_id: chatRoom.id });
    }
  }, [chatRoom, socket]);

  const handleBackButtonClick = () => {
    setChatRoom({});
  };

  const handleMessageModalOpen = (item) => {
    setMessageDeleteModal(true);
    setMessage(item);
  };

  const handleSendMessage = async () => {
    const message = messageRef.current.value;
    if (!message && _.isUndefined(media)) return;

    try {
      const payload = {};

      //   if (!_.isUndefined(media)) {
      //     const formData = new FormData();
      //     formData.append("file", media);
      //     const res = await axios({
      //       method: "POST",
      //       url: UPLOAD_URL,
      //       data: formData,
      //       headers: {
      //         Token: INITIAL_TOKEN,
      //         "Content-Type": "multipart/form-data",
      //       },
      //     });

      //     payload.message_type = MESSAGE_TYPE_ENUM.FILE;
      //     payload.file_type = getFileType();
      //     payload.file_name = media.name;
      //     payload.file_url = res?.data?.data?.link;
      //   } else {
      payload.message_type = "TEXT";
      //   }
      payload.chat_room_id = chatRoom.id;
      payload.message = message;
      payload.message_uuid = uuidv4();
      setChatHistory((prev) => {
        return {
          ...prev,
          data: [
            ...prev?.data,
            {
              ...payload,
              user_id: user.id,
              user_name: user.name,
              user_image: user.image_url,
              message_timestamp: new Date(),
            },
          ],
        };
      });
      socket.emit("_sendMessage", payload);
      messageRef.current.value = "";
      setMedia(undefined);
    } catch (err) {
      Toast(err?.message, "error");
    }
  };

  const handleDeleteMessage = () => {
    console.log(message);
    socket?.emit("_deleteChatMessage", {
      message_id: message.message_id,
      is_fromEveryone: true,
    });
    setMessageDeleteModal(false);
    // setPopupData({});
  };

  const handleMessageModalClose = useCallback(() => {
    setMessageDeleteModal(false);
  }, []);

  return (
    <div className={styles.Inbox}>
      {isMessageDeleteModal ? (
        <DeleteModal
          handleDeleteModalClose={handleMessageModalClose}
          //   data={editedData}
          //   isDeleting={isDeleting}
          onDelete={handleDeleteMessage}
        />
      ) : (
        ""
      )}
      <div className={styles.titleContainer}>
        <div className={styles.userContainer}>
          <div className={styles.imageContainer}>
            {isMobile ? (
              <span
                className={styles.backButton}
                onClick={handleBackButtonClick}
              >
                <IoIosArrowBack />
              </span>
            ) : (
              ""
            )}

            <img
              className={styles.image}
              src={chatRoom?.image_url || "/images/no_image_available.png"}
              alt="User Profile"
            />
            <span className={styles.online}></span>
          </div>
          <div className={styles.nameContainer}>
            <CardTitle text={chatRoom.room_name} classes="lc-1" />
            {/* <p className={styles.online}>Online</p> */}
          </div>
        </div>
      </div>
      <div
        className={styles.chatContainer}
        id="chatContainer"
        ref={chatContainerRef}
      >
        {_.isEmpty(chatRoom) ? (
          <p className={`${styles.noThreads} text-white-50 text-center`}>
            Select any user
          </p>
        ) : !_.isEmpty(chatRoom) && chatHistory?.isLoading ? (
          <span className={`${styles.noThreads} text-center`}>
            <Spinner variant="success" />
          </span>
        ) : _.isEmpty(chatHistory?.data) ? (
          <p className={`${styles.noThreads} text-center`}>Empty Inbox</p>
        ) : (
          (chatHistory?.data ?? []).map((item, index) => {
            // console.log(item);
            const isMe = item?.user_id === user?.id;
            return (
              <div
                key={item?.id || item?.message_uuid}
                className={`${styles.chat} ${isMe ? styles.me : ""}`}
              >
                <span className={styles.info}>
                  {getMessageTime(item?.message_timestamp)}
                </span>

                <div className={styles.messageWrapper}>
                  {isMe && (
                    <FaTrashAlt
                      className={styles.deleteIcon}
                      //   onClick={() => handleDeleteMessage(item)}
                      onClick={() => handleMessageModalOpen(item)}
                      title="Delete message"
                    />
                  )}
                  <p className={`${styles.message} ${isMe ? styles.me : ""}`}>
                    {item.message || ""}
                  </p>
                </div>

                {isMe ? <span className={styles.info}>Seen</span> : ""}
              </div>
            );
          })
        )}
      </div>

      <div className={styles.messageContainer}>
        <Form.Control
          size="lg"
          className={`mt-1 mb-2  ${styles.messageBar}`}
          placeholder={"Type a message"}
          type="text"
          ref={messageRef}
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              handleSendMessage();
              e.stopPropagation();
            }
          }}
        />
        <button className={`${styles.sendButton}`} onClick={handleSendMessage}>
          <FiSend />
        </button>
      </div>
    </div>
  );
}
